<template>
  <div class="mix-line-container">
    <div id="pieContainer" class="pie-container"></div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    data: Array,
    type: Number,
    colors: {
      type: Array,
      default: () => []
    },

    jumpName: {
      type: String
    }
  },
  data() {
    return {
      piePlot: null
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        this.init()
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.init()
      }, 100)
    })
  },
  methods: {
    init() {
      this.piePlot = this.$echarts.init(document.getElementById('pieContainer'))
      let all = 0
      this.data.forEach(item => {
        all += item.value
      })
      let option = {
        title: {
          text: `总异常数`,
          align: "center",
          top: "36%",
          left: "49.3%",
          textAlign: "center",
          textStyle: {
            textAlign: "center",
            fontSize: 12,
            lineHeight: 24
          },
          subtext: all,
          subtextStyle: {
            color: "#000",
            fontSize: 38,
            fontWeight: 'bold',
            marginTop: 30
          }
        },
        legend: {
          bottom: 0
        },
        series: [
          {
            type: 'pie',
            left: 'center',
            radius: ['60%', '90%'],
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },

            grid: {
              left: 20,
              right: 40
            },
            avoidLabelOverlap: true,
            label: {
              // show: false,
              color: '#fff',
              distanceToLabelLine: -10,
              lineHeight: 20,
              formatter: `{b|{b}} \n {c|{c}}`,
              rich: {
                b: {
                  fontSize: 12,
                  color: '#999',
                  width: 100,
                  align: 'center'
                },
                c: {
                  color: '#333',
                  fontWeight: 'bold',
                  lineHeight: 33,
                  height: 20,
                  fontSize: 14,
                  padding: [15, 0, 0, 0],
                  width: 100,
                  align: 'center'
                }
              }
            },
            labelLine: {
              lineStyle: {
                width: 2,
                color: '#4683FF',
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            color: this.colors.concat([
              '#2D6AF6',
              '#FFAD42',
              '#6EB1ED',
              '#FF7646',
              '#49DCF4',
              '#726EED',
              '#D76EED',
              '#4BD468'
            ]),
            data: this.data.map((item) => {
              return {
                ...item,
                name: item.type
              }
            })
          }
        ]
      }
      this.piePlot.setOption(option)
      // this.piePlot.on('click', (param) => {
      //   this.clickFunc(param)
      // })
      window.addEventListener('resize', () => {
        this.piePlot.resize()
      })
    },
    clickFunc(param) {
      let code = 0
      switch (param.name) {
        case '解析率＜50% /h':
          code = 0
          break
        case '采集量＞1w条 /h':
          code = 1
          break
        case '24h内采集量为0':
          code = 2
          break
        default:
          break
      }
      this.$router.push({
        name: 'monitor_abnormal',
        query: {
          name: code,
          value: param.value,
          time:
            this.type === 0
              ? [
                  moment().format('YYYY-MM-DD') + ' 00:00:00',
                  moment().format('YYYY-MM-DD') + ' 23:59:59'
                ]
              : [
                  moment(new Date()).add(-1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
                  moment(new Date()).add(-1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
                ]
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mix-line-container {
  background: white;
  width: 100%;
  height: 334px;
}

.pie-container {
  width: 100%;
  height: 100%;
}
</style>
